export default __webpack_public_path__ + "static/media/logo.eaddb122.svg";